import { IObservable, Observable } from '@1js/oil-externals/rx';
import { CommercialApps } from '../models/app.model';
import { SearchResultType } from '../search-instrumentation.service';
import { BaseSuggestionProvider } from './base.search-suggestion-provider';

export class GoToSearchSuggestionProvider extends BaseSuggestionProvider {
    public static commercialApps: CommercialApps;
    private static readonly MIN_NUM_OF_CHARS: number = 2;
    private static readonly MAXCOUNT: number = 3;

    public createStream(searchText: string): IObservable<any> {

        const renderedResults: Array<string> = [];
        const apps: Array<object> = [];

        if (searchText?.trim() !== '') {
            const result: Array<object> = [];
            let text: string = searchText.replace(/\s/g, '').toLowerCase();

            // if search text starts with 'ms' or 'microsoft', remove them to have a better match.
            if (text.startsWith('ms')) {
                text = text.split('ms')[1];
            } else if (text.startsWith('microsoft')) {
                text = text.split('microsoft')[1];
            }

            if (text.length >= GoToSearchSuggestionProvider.MIN_NUM_OF_CHARS) {
                GoToSearchSuggestionProvider.commercialApps.getCommercialAppList().forEach(app => {
                    const name: string = app['AppName'].replace(/\s/g, '').toLowerCase();
                    if ( text.indexOf(name) === 0 || name.indexOf(text) === 0) {
                        result.push(app);
                        if (result.length === GoToSearchSuggestionProvider.MAXCOUNT) {
                            return false;
                        }
                    }
                });
            }

            result.forEach(app => {
                apps.push({
                    id: decodeURI(app['Url']),
                    isPwa: GoToSearchSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                    isDarkMode: GoToSearchSuggestionProvider.isDarkMode,
                    title: app['Title'],
                    iconClass: app['IconUnicodeCodepointCssClass'],
                    url: app['Url'],
                    referral: app['Referral'],
                    searchInstrumentationService: GoToSearchSuggestionProvider.searchInstrumentationService,
                    urlLauncherService: GoToSearchSuggestionProvider.urlLauncherService
                });
                renderedResults.push(app['Title']);
            });
        }

        GoToSearchSuggestionProvider.searchInstrumentationService.setRenderedProviderResults(SearchResultType.GoTo, renderedResults);
        return Observable.fromArray(apps);
    }

    public getId(): string {
        return 'goTo';
    }
}
